import request from '@/utils/request'

export function fetchMchScopeList(params) {
  return request({
    url: '/merchant-api/kyc/optionList',
    method: 'get',
    params
  })
}

// 获取KYC商户信息
export function getMerchantKycInfo(params) {
  return request({
    url: '/merchant-api/kyc/getKycDetail',
    method: 'get',
    params
  })
}

export function fetchMchScopeAllList(params) {
  return request({
    url: '/merchant-api/kyc/scopeAllList/' + params,
    method: 'get'
  })
}

// 保存或更新公司基本信息
export function updateCompanyBasicInfo(data) {
  return request({
    url: '/merchant-api/kyc/updateCompanyBasicInfo',
    method: 'post',
    data
  })
}

// 保存或更新公司文件
export function updateCompanyDocument(data) {
  return request({
    url: '/merchant-api/kyc/updateCompanyDocument',
    method: 'post',
    data
  })
}

// 保存或更新账户信息
export function updateAccountInfo(data) {
  return request({
    url: '/merchant-api/kyc/updateAccountInfo',
    method: 'post',
    data
  })
}

// 保存或更新签字人信息
export function updateSignatoryInfo(data) {
  return request({
    url: '/merchant-api/kyc/updateSignatoryInfo',
    method: 'post',
    data
  })
}

// 提交KYC申请
export function submitKyc() {
  return request({
    url: '/merchant-api/kyc/submit',
    method: 'get'
  })
}
